<template>
  <div class="resource-playlist">
    <div class="playlist-header">
      <div class="container maxWidth-sm">
        <div class="row">
          <div class="col-sm-7">
            <img src="../../assets/playlist-icon.png" class="playlist-icon" alt="playlist icon" />
            <h1 v-if="title">
              {{ title }}
            </h1>
            <div v-html="descriptionHtml"></div>
            <div style="height: 10px"></div>
            <p>
              <a class="btn btn-primary" v-if="hasOverview" :href="overviewUrl">{{
                overviewTitle
              }}</a>
            </p>
          </div>
          <div class="col-sm-5">
            <CmsImg style="width: 100%" :src="titleImage" />
          </div>
        </div>
      </div>
    </div>
    <div class="resource-playlist-resources text-center">
      <ResourceTile
        :key="item.title"
        v-for="item in items"
        :src="item.src"
        :title="item.title"
        :href="item.href"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { debug as d } from "debug";
import { computed, onMounted } from "vue";
import {
  CmsDocument,
  CmsResourcePlaylist,
  CmsResourceRelationship,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import CmsImg from "../../components/cms/cms-img.vue";

import ResourceTile from "../../components/cms/resource-tile.vue";

const debug = d("cs.CmsResourcePlaylist");

const props = defineProps<{ doc: CmsDocument }>();
const doc = computed(() => props.doc as CmsResourcePlaylist);

onMounted(() => {
  debug("Mounting");
});

const title = computed(() => cms.asText(doc.value.data.title));
const hasOverview = computed(() => !!doc.value.data.overview_button_link?.uid);
const resources = computed(() => doc.value.data.items.map((i) => i.link) ?? []);
const overviewTitle = computed(() =>
  !hasOverview.value ? "" : cms.asText(doc.value.data.overview_button_title) || "Overview",
);
const overviewUrl = computed(() => cms.linkResolver(doc.value.data.overview_button_link));
const descriptionHtml = computed(() => cms.asHtml(doc.value.data.description));
const titleImage = computed(() => doc.value.data.title_image);
const items = computed(() => {
  return doc.value.data.items.map((i) => {
    const { data } = i.link as CmsResourceRelationship;
    return {
      href: cms.linkResolver(i.link),
      title: cms.asText(data?.tile_title).trim() || cms.asText(data?.title),
      src: data?.tile_image_animation?.url || data?.title_image?.tile || data?.title_image,
    };
  });
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import (reference) "../../styles/bootstrap/bootstrap.less";

.resource-playlist {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

.playlist-header {
  background-color: #eee;
  width: 100%;
  padding-top: 15px;
  padding-bottom: 20px;
  box-shadow: 0px 3px 3px #ccc;
}

.playlist-icon {
  width: 100px;
  margin-bottom: -12px;
}

.resource-playlist-resources {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-content: flex-start;
  max-width: 750px; // Maximum of 3 tiles across
}
</style>
